import * as React from 'react';
import styles from './installation.module.css';
export const Installation = ({ assets, }) => {
    return (React.createElement("div", { className: styles.Installation }, assets.map(({ url }) => (React.createElement("img", { key: url, src: url })))));
};
